import { OrderActionTypes } from "./constants";

export const setOrders = (orders) => ({
  type: OrderActionTypes.SET_ORDERS,
  payload: orders,
});

export const setOrdersError = (error) => ({
  type: OrderActionTypes.SET_ORDERS_ERROR,
  payload: error,
});

export const setSelectedOrder = (order) => ({
  type: OrderActionTypes.SET_SELECTED_ORDER,
  payload: order,
});

export const setExpandedOrder = (orderId) => ({
  type: OrderActionTypes.SET_EXPANDED_ORDER,
  payload: orderId,
});

export const updateOrder = (order) => ({
  type: OrderActionTypes.UPDATE_ORDER,
  payload: order,
});

export const setOrder = (order) => ({
  type: OrderActionTypes.SET_ORDER,
  payload: order,
});

export const setOrderError = (error) => ({
  type: OrderActionTypes.SET_ORDER_ERROR,
  payload: error,
});

export const setOrderSearchResults = (results) => ({
  type: OrderActionTypes.SET_ORDER_SEARCH_RESULTS,
  payload: results,
});

export const setOrderSearchError = (error) => ({
  type: OrderActionTypes.SET_ORDER_SEARCH_ERROR,
  payload: error,
});

export const activateTicket = (projectId, orderId, ticketId) => ({
  type: OrderActionTypes.ACTIVATE_TICKET,
  payload: { projectId, orderId, ticketId },
});

export const activateTicketSuccess = () => ({
  type: OrderActionTypes.ACTIVATE_TICKET_SUCCESS,
});

export const activateTicketError = (error) => ({
  type: OrderActionTypes.ACTIVATE_TICKET_ERROR,
  payload: error,
}); 